export default __webpack_public_path__ + "static/media/jost-700-bold.b12748b2.woff";